import i18n from "src/translationService";

export const getApiLanguage = (language?: string) => {
  const code = (language ?? i18n.language ?? "en").toLowerCase();

  if (code.startsWith("it")) return "it";
  return "en";
};

export const getLanguageHeaders = (language?: string) => ({
  headers: {
    "Accept-Language": getApiLanguage(language),
  },
});

export const languageHeaders = getLanguageHeaders();
